import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionDescription(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.aboutDescription)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >

          <h2 className={classes.description, classes.textCenter}>
            Buy and sell real estate
          </h2>
          <h3>Buy, negotiate, sell, invest, grow, Winning</h3>
          <h5>
            Leverage Kinos and Torus Network’s presence in Spain, Portugal and 120+ countries to satisfy your commercial, industrial, and residential real estate needs.
          </h5>
          <h5>Whether you want to acquire or sell assets to meet your investment or operational goals, we connect you directly to the principal decision-maker.  </h5>

          <h2 className={classes.description, classes.textCenter}>
            Source unique investment and co-investment deals
          </h2>
            Meet your investment objectives with direct access to companies seeking capital and funds looking for LPs in over  Spain, Portugal and more 100 countries.
            Set your industry, geography, and deal size preferences to meet your investment mandate.
            <h2 className={classes.description, classes.textCenter}>
            Find buyers for your asset or  business
            </h2>
            More 100.000 Customers are with us.
            When you decide to sell your assets or company, finding the right buyer is critical for the continued success of your business, employees, and other stakeholders.
            Post your opportunity anonymously and get matched directly with interested buyers.

        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(SectionDescription);
